// extracted by mini-css-extract-plugin
module.exports = {"pageBtns_wrapper":"Pagination_pageBtns_wrapper__l1ozI","pageBtn":"Pagination_pageBtn__TyLHP"};